<template>
  <div class="area-vertex-coordinates-card">
    <EmptyAreaComponent v-if="areaVerticesListIsEmpty" />
    <div
      v-else
      class="area-vertex-coordinates-item-list"
    >
      <div
        v-for="(item, index) in getVertexCoordinates"
        :key="item"
        class="area-vertex-coordinates-item"
      >
        <div class="area-vertex-coordinates-item-counter">
          {{ index }}
        </div>

        <div class="area-vertex-coordinates-item-content">
          <strong>{{ `${item[0].toFixed(3)} , ${item[1].toFixed(3)}` }}</strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import EmptyAreaComponent from "./EmptyArea.vue";
export default {
  name: "AreaVertexCoordinatesComponent",
  components: {
    EmptyAreaComponent,
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapGetters("weatherRouting/createCustomAreaModule", [
      "getVertexCoordinates",
    ]),
    areaVerticesListIsEmpty() {
      return this.getVertexCoordinates.length === 0;
    },
  },
};
</script>

<style scoped>
.area-vertex-coordinates-item-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.area-vertex-coordinates-card {
  height: 500px;
  width: 100%;
  overflow-y: auto;
  padding: 16px;
  background-color: var(--color-surface);
  border-radius: 8px;
  border: 1px solid var(--color-border);
}
.area-vertex-coordinates-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background-color: var(--color-surface);
  border-radius: 8px;
  border: 1px solid var(--color-border);
}
.area-vertex-coordinates-item-counter {
  width: 24px;
  height: 24px;
  background-color: var(--color-secondary);
  color: var(--color-text);
  border: 1px solid var(--color-border);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
}
.area-vertex-coordinates-item-content {
  font-size: 16px;
  color: var(--color-text);
}
</style>

<!--
.area-vertex-coordinates-item-action-button {
  background-color: var(--color-secondary) !important;
  color: var(--color-text) !important;
}
-->
